import {
  TextField,
  Box,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from "@mui/material";
import { useState, useEffect } from "react";
import DataTextField from "./DataTextField";
import { query, where } from "firebase/firestore"; // Add this

import {
  getFirestore,
  doc,
  getDoc,
  updateDoc,
  arrayUnion,
  getDocs,
  collection,
} from "firebase/firestore";
import MostRecentEntryInDB from "./MostRecentEntryInDB";
import { db } from "../../firebase/FirebaseConfig";

const PickDataEntry2 = () => {
  const [songOrAlbumName, setSongOrAlbumName] = useState("");
  const [artistName, setArtistName] = useState("");
  const [memberName, setMemberName] = useState("");
  const [songOrAlbumArt, setSongOrAlbumArt] = useState("");
  const [pickTypeSelectState, setPickTypeSelectState] = useState("");
  const [quarterSelectState, setQuarterSelectState] = useState("");
  const [yearSelectState, setYearSelectState] = useState("");
  const [weekSelectState, setWeekSelectState] = useState("");
  const [status, setStatus] = useState("");
  const [openDoubleCheckPick, setOpenDoubleCheckPick] = useState(false);

  const pickTypeOptions = [
    "Album of the Week",
    "Runner Up Album of the Week",
    "Song of the Week",
    "Runner Up Song of the Week",
  ];
  const quarterSelectOptions = ["FQ", "WQ", "SQ"];
  const yearSelectOptions = [
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
  ];
  const weekSelectOptions = [
    "WEEK 1",
    "WEEK 2",
    "WEEK 3",
    "WEEK 4",
    "WEEK 5",
    "WEEK 6",
    "WEEK 7",
    "WEEK 8",
    "WEEK 9",
    "WEEK 10",
    "WEEK 11",
  ];
  useEffect(() => {
    const fetchLatestQuarter = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "pickData"));
        const allQuarters: any[] = [];

        querySnapshot.forEach((docSnap) => {
          allQuarters.push({ ...docSnap.data(), docId: docSnap.id });
        });

        const latestQuarter = allQuarters.sort(
          (a, b) => b.quarterId - a.quarterId
        )[0];

        if (latestQuarter?.quarterName) {
          const quarterName = latestQuarter.quarterName;
          setQuarterSelectState(quarterName.slice(0, 2)); // e.g., "SQ"
          setYearSelectState(quarterName.slice(2)); // e.g., "25"
        }
      } catch (err) {
        console.error("Error fetching latest quarter:", err);
      }
    };

    fetchLatestQuarter();
  }, []);

  const handleDoubleCheckPickDialogOpen = () => {
    if (songOrAlbumName && artistName && memberName) {
      setOpenDoubleCheckPick(true);
    } else {
      alert("❌ All fields must be filled out.");
    }
  };
  const mapPickTypeToField = (pickType: string): string | null => {
    switch (pickType) {
      case "Album of the Week":
        return "AotW";
      case "Runner Up Album of the Week":
        return "RUAotW";
      case "Song of the Week":
        return "SotW";
      case "Runner Up Song of the Week":
        return "RUSotW";
      default:
        return null;
    }
  };

  const handleDoubleCheckPickDialogClose = () => {
    setOpenDoubleCheckPick(false);
  };

  const handleDoubleCheckPickDialogCloseOK = async () => {
    setOpenDoubleCheckPick(false);
    await handlePickFormSubmit();
  };

  const handlePickFormSubmit = async () => {
    const quarterName = `${quarterSelectState}${yearSelectState}`;

    try {
      const q = query(
        collection(db, "pickData"),
        where("quarterName", "==", quarterName)
      );
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        setStatus("❌ Selected quarter/year not found.");
        return;
      }

      const docSnap = querySnapshot.docs[0];
      const docRef = doc(db, "pickData", docSnap.id);
      const data = docSnap.data();

      let weeks = data.weeks;
      if (!Array.isArray(weeks)) {
        weeks = [];
      }

      // Find highest pickId for Runner Up Song of the Week
      let lastRUSotWId = 100;
      weeks.forEach((week: any) => {
        week.picks?.forEach((pick: any) => {
          if (
            pick.pickType === "Runner Up Song of the Week" &&
            pick.pickId > lastRUSotWId
          ) {
            lastRUSotWId = pick.pickId;
          }
        });
      });

      const typeOffsets: any = {
        "Album of the Week": 1,
        "Runner Up Album of the Week": 2,
        "Song of the Week": 3,
        "Runner Up Song of the Week": 4,
      };

      const pickId = lastRUSotWId + (typeOffsets[pickTypeSelectState] || 5);
      const newPick = {
        pickId,
        pickType: pickTypeSelectState,
        songOrAlbumName,
        artistName,
        memberName,
        songOrAlbumArt,
      };

      const weekIndex = weeks.findIndex(
        (week: any) => week.weekName === weekSelectState
      );

      if (weekIndex !== -1) {
        // Week exists: add pick to the week
        const existingPicks = weeks[weekIndex].picks || [];
        const updatedPicks = [...existingPicks, newPick];
        weeks[weekIndex].picks = updatedPicks;
      } else {
        // Week does not exist: create it
        const newWeek = {
          weekName: weekSelectState,
          picks: [newPick],
        };
        weeks = [...weeks, newWeek];
      }

      // Finally, update the entire weeks array
      await updateDoc(docRef, { weeks });

      setStatus("✅ Pick added successfully.");
    } catch (err) {
      console.error(err);
      setStatus("❌ Failed to add pick.");
    }
  };

  return (
    <div className="faq">
      <Box>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          <h1>ADD NEW PICKS</h1>
          <MostRecentEntryInDB comp={"addpick"} />
          <div style={{ marginTop: 20 }}>
            <FormControl sx={{ width: 260, marginRight: 3 }} size="small">
              <InputLabel>Pick Type</InputLabel>
              <Select
                value={pickTypeSelectState}
                onChange={async (e) => {
                  const newPickType = e.target.value;
                  setPickTypeSelectState(newPickType);

                  const firestoreField = mapPickTypeToField(newPickType);
                  if (!firestoreField) return;

                  try {
                    const docRef = doc(db, "picksToAdd", "nextWeeksPicks");
                    const docSnap = await getDoc(docRef);

                    if (docSnap.exists()) {
                      const data = docSnap.data();
                      const member = data?.nextWeek?.[firestoreField];
                      if (member) {
                        console.log("Autofilling member:", member);
                        setMemberName(member); // ✅ this should work
                      }
                    }
                  } catch (err) {
                    console.error("Error autofilling member name:", err);
                  }
                }}
              >
                {pickTypeOptions.map((p) => (
                  <MenuItem key={p} value={p}>
                    {p}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl sx={{ width: 80, marginRight: 3 }} size="small">
              <InputLabel sx={{ width: 80 }}>Quarter</InputLabel>
              <Select
                value={quarterSelectState}
                onChange={(e) => setQuarterSelectState(e.target.value)}
                size="small"
              >
                {quarterSelectOptions.map((q) => (
                  <MenuItem value={q}>{q}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ width: 70, marginRight: 3 }} size="small">
              <InputLabel>Year</InputLabel>
              <Select
                value={yearSelectState}
                onChange={(e) => setYearSelectState(e.target.value)}
              >
                {yearSelectOptions.map((y) => (
                  <MenuItem value={y}>{y}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ width: 120 }} size="small">
              <InputLabel>Week</InputLabel>
              <Select
                value={weekSelectState}
                onChange={(e) => setWeekSelectState(e.target.value)}
                size="small"
              >
                {weekSelectOptions.map((w) => (
                  <MenuItem value={w}>{w}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "center",
            marginRight: 2,
          }}
        >
          <DataTextField
            required={true}
            label="Album/Song Name"
            errorMsg={"Need Album/Song Name"}
            setValue={setSongOrAlbumName}
            value={songOrAlbumName}
          />
          <DataTextField
            required={true}
            label="Artist Name"
            errorMsg={"Need Artist Name"}
            setValue={setArtistName}
            value={artistName}
          />
          <DataTextField
            required={true}
            errorMsg={"Need Member Name"}
            label="Member Name"
            setValue={setMemberName}
            value={memberName} // ✅ this makes it controlled
          />

          <DataTextField
            required={false}
            errorMsg={" "}
            label="SpotifyAPI Art Link"
            setValue={setSongOrAlbumArt}
            value={songOrAlbumArt}
          />
          <Button variant="contained" onClick={handleDoubleCheckPickDialogOpen}>
            Add Pick
          </Button>
        </div>
        <Dialog
          open={openDoubleCheckPick}
          onClose={handleDoubleCheckPickDialogClose}
        >
          <DialogTitle>Confirm Pick</DialogTitle>
          <DialogContent>
            <h3>{songOrAlbumName}</h3>
            <p>{artistName}</p>
            <p>{memberName}</p>
            {songOrAlbumArt && (
              <img src={songOrAlbumArt} style={{ width: 150, height: 150 }} />
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDoubleCheckPickDialogClose}>Cancel</Button>
            <Button onClick={handleDoubleCheckPickDialogCloseOK}>Ok</Button>
          </DialogActions>
        </Dialog>
        <p>{status}</p>
      </Box>
    </div>
  );
};

export default PickDataEntry2;
